import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class ScrollService {
    constructor(platformId, router) {
        this.platformId = platformId;
        this.router = router;
    }
    scrollToTopOnNavigationEnd() {
        if (isPlatformBrowser(this.platformId)) {
            this.router.events.subscribe((event) => {
                window.scroll(0, 0);
            });
        }
    }
    scrollToContentOnNavigationEnd() {
        if (isPlatformBrowser(this.platformId)) {
            this.router.events.subscribe((event) => {
                const element = document.querySelector('app-root');
                element ? element.scrollIntoView() : undefined;
            });
        }
    }
    scrollToId(id) {
        if (isPlatformBrowser(this.platformId)) {
            const element = document.querySelector('#' + id);
            if (element) {
                element.scrollIntoView();
            }
        }
    }
}
ScrollService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScrollService_Factory() { return new ScrollService(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i1.Router)); }, token: ScrollService, providedIn: "root" });
